import type { TDisplayColumnData } from 'components/data/types';
import {
  SimpleAssetFilter,
  SiteFilter,
  WorkOrderComponentFilter,
} from 'components/DataTable/customFilters';
import type { CustomFilterDropdownProps } from 'horizon/types/TableColumnDef';

import {
  clientAtlasTaskComponent,
  clientAtlasTaskSites,
  clientAtlasTaskTurbines,
  serverAtlasTaskComponent,
  serverAtlasTaskSites,
  serverAtlasTaskTurbines,
} from '../tasks';

import { WORK_ORDER_TURBINE_REQUIRES_SITE_TOOLTIP } from './workOrderTableColumns';

export const taskSitesColumn = (
  isCollaborator: boolean,
  clientSide = false
): TDisplayColumnData => {
  const base = clientSide
    ? clientAtlasTaskSites(isCollaborator)
    : serverAtlasTaskSites(isCollaborator);

  return {
    ...base,
    excludeFromServerFilter: true,
    filterDropdown: (props: CustomFilterDropdownProps) => <SiteFilter {...props} />,
  };
};

export const taskTurbinesColumn = (
  isCollaborator: boolean,
  clientSide = false
): TDisplayColumnData => {
  const base = clientSide
    ? clientAtlasTaskTurbines(isCollaborator)
    : serverAtlasTaskTurbines(isCollaborator);

  return {
    ...base,
    excludeFromServerFilter: true,
    requiresSiteFilter: true,
    requiresSiteFilterTooltip: WORK_ORDER_TURBINE_REQUIRES_SITE_TOOLTIP,
    filterDropdown: (props: CustomFilterDropdownProps) => (
      <SimpleAssetFilter
        assetTypeName="Turbine"
        requireSiteFilter
        requireSiteFilterTooltip={WORK_ORDER_TURBINE_REQUIRES_SITE_TOOLTIP}
        {...props}
      />
    ),
  };
};

export const taskComponentColumn = (
  isCollaborator: boolean,
  clientSide = false
): TDisplayColumnData => {
  const base = clientSide
    ? clientAtlasTaskComponent(isCollaborator)
    : serverAtlasTaskComponent(isCollaborator);

  return {
    ...base,
    // Keep the existing Task table column key so persisted column layouts survive the move
    // from the top-level asset chooser into this column filter.
    allKeys: ['asset', 'componentType'],
    excludeFromServerFilter: true,
    filterDropdown: (props: CustomFilterDropdownProps) => <WorkOrderComponentFilter {...props} />,
  };
};
